module.exports = __webpack_public_path__ + "assets/8b0722adb990b3170cd4d9e5b18657c1.mp3";